export function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        // eslint-disable-next-line no-invalid-this
        var context = this,
            args = arguments,
            later = () => {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            },
            callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
